import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { CommonserviceService } from './services/commonservice.service';
import { DataService } from './services/data.service';

@Injectable()
export class pieAuthInterceptor implements HttpInterceptor {
  constructor(private commonService: CommonserviceService, private dataService: DataService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.dataService.getPieToken();
    let authReq = req;
    
    if (token) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Token expired, refresh the token
          return this.commonService.getPieToken().pipe(
            switchMap((response: any) => {
              this.dataService.setPieToken(response?.accessToken);
              const newToken = response?.accessToken;
              const newAuthReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`
                }
              });
              return next.handle(newAuthReq);
            }),
            catchError((err) => {
              // Handle token refresh error
              return throwError(err);
            })
          );
        } else {
          return throwError(error);
        }
      })
    );
  }
}